<!-- BCT: MOdified for HB-76 -->
<template>
    <div style="position: absolute; top:0; bottom: 64px; width: 100%; ">
      <v-card flat class="edit-panel"  style="height: 100%; overflow-y: auto">

        <v-container class="hb-table">
            <v-row class="hb-table-row">
              <v-col class="hb-table-label pl-6 pt-4" cols="4">
                Available / Offline
              </v-col>
              <v-col class="hb-table-value" cols="4">
                <v-radio-group  
                    hide-details 
                    v-model="form.status" 
                    :error-messages="errors.collect('Status')"
                    v-validate="'required'"
                >
                  <v-radio dense label="Available Spaces" value="1"></v-radio>
                  <v-radio dense label="Offline Spaces" value="0"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="4">
                <v-select
                  class="mt-4"
                  v-if="show_secondary_status"
                  single-line
                  label="Secondary Status"
                  hide-details
                  :items="secondary_statuses"
                  v-model="form.sec_status"
                  v-validate="'required'"
                  data-vv-name="Secondary Status"
                  :error-messages="errors.collect('Secondary Status')"
                >
                </v-select>
              </v-col>
            </v-row>

            <v-row class="hb-table-row">
              <v-col class="hb-table-label pl-6 pt-4" cols="4">
               Reason
              </v-col>
              <v-col class="hb-table-value">
                <HbTextarea
                  :rows=6 
                  row-height="15" 
                  :clearable="true"
                  v-model="reason"
                  v-validate="'required|max: 255'" 
                  :maxlength="255" 
                  ref="Reason"
                  data-vv-scope="Reason" 
                  data-vv-name="Reason"
                  data-vv-as="Reason" 
                  :error-messages="errors.collect('Reason')"
                  placeholder="Reason for status change" 
                  placeholder-fix 
                />
              </v-col>
            </v-row>

        </v-container>
      </v-card>
  
      <div class="bottom-bar-position">
        <hb-bottom-action-bar @close="back()">
          <template v-slot:right-actions>
            <hb-btn color="primary" @click="save">Save</hb-btn>
          </template>
        </hb-bottom-action-bar>
      </div>


      <hb-modal
        confirmation
        v-if="showStatusConfirmation"
        v-model="showStatusConfirmation"
        size="medium"
        :title="`Change Spaces to ${form.status ? 'Available': form.sec_status}`"
        :footerCancelOption="false"
        @close="showStatusConfirmation = false"
        show-help-link
        >
        <template v-slot:content>
            <div class="pa-6">
            {{`Changing spaces to ${form.status ? 'Available': form.sec_status} will ${form.status ? 'add': 'remove'} all selected spaces ${form.status ? 'to': 'from'} the available inventory.`}}
            </div>
            <div class="pl-6 pb-6">
            {{`Are you sure you want to change all the selected spaces to ${form.status ? 'Available': form.sec_status}?`}}
            </div>
        </template>
        <template v-slot:right-actions>
            <hb-btn @click="save(true)" color="primary">{{`Change ${getBulkUnitIds.length || items.length} Space${items.length > 1 ? 's' : ''}`}}</hb-btn>
        </template>
    </hb-modal>
  
    </div>
  </template>
  
<script>
    import api from '../../../assets/api.js';
    import HbDatePicker from '../../assets/HummingbirdDatepicker';
    import { EventBus } from '../../../EventBus.js';
    import { mapGetters, mapActions } from 'vuex';
    import { notificationMixin } from  '@/mixins/notificationMixin.js';

  
      export default {
          name: "BulkEditUnitStatus",
          data() {
              return {
                secondary_statuses:[
                    'To Clean',
                    'Company',
                    'Maintenance',
                    'Inactive'
                ],
                show_secondary_status:false,
                showStatusConfirmation: false,
                units: [],
                form:{
                    status: '',
                    sec_status: ''
                },
                reason:''
              }
          },
          props: ['items', 'template'],
          mixins: [notificationMixin],
  
          created(){
            this.getUnitDetails();
          },
          computed:{
              ...mapGetters({
                bulk_edit_items: 'bulkEditStore/items',
                properties: "propertiesStore/filtered",
                getBulkUnitIds: 'reportStore/getBulkUnitsList',
              }),
              sections(){
                  return [...new Set(this.config.columns.map(({ group }) => group))]
              },
              all_storage(){
                  return this.units.filter(u => u.type === 'storage').length === this.units.length;
              },
              all_residential(){
                  return this.units.filter(u => u.type === 'residential').length === this.units.length;
              },
              all_parking(){
                  return this.units.filter(u => u.type === 'parking').length === this.units.length;
              },
              all_pod(){
                  return this.units.filter(u => u.type === 'pod').length === this.units.length;
              }
          },
          methods:{
            ...mapActions({
                resetAction: 'bulkEditStore/resetAction',
                addBulkUnits: 'reportStore/addBulkUnits',
            }),
            closeWindow(){
                this.resetAction();
            },
            async getUnitDetails(){
                let unit_ids = this.getBulkUnitIds.map(unit=> { return {id:unit.unit_id} }) || []
                let items = this.items.map(item => { return {id:item.unit_id} });
                let response = await api.post(this, api.UNITS + 'bulk-config', {unit_ids: unit_ids.length? unit_ids:items});
                this.units = response.units || [];
            },
            async save(statusConfirmed){
                let units_data = this.getBulkUnitIds.length ? this.getBulkUnitIds : this.items
                let spacesNumbers = units_data.map(a => a.number || a.unit_number);
                let status = await this.validate(this)
                if (!status) return;

                if(!statusConfirmed) {
                  this.showStatusConfirmation = true;
                  return;
                }

                let data = {
                    unit_ids: units_data.map(item => {
                      return {
                        id: item.unit_id
                      }
                    }),
                    form: this.form,
                    reason:this.reason
                };
                try{
                 await api.put(this, api.UNITS + 'bulk-edit', data )
                  let msg = `Spaces ${spacesNumbers.join(', ')} have been moved to ${ this.form?.status === 1 ? 'Available' : this.form?.sec_status}.`
                  this.showMessageNotification({type: 'success', description: msg});
                  EventBus.$emit('unit_edited');
                  this.$emit('cancel');
                  this.addBulkUnits([]);
                }catch(err){
                  this.showMessageNotification({type: 'error', description: err});
                }  
            },
            back() {
              this.$emit('cancel');
            }
          },
          watch:{
            "errors.items"(val) {
                if(val && val.length) {
                    if (val[0].field === "Status" && val[0].rule === "required" ) {
                        val[0].msg = "Available / Offline is missing a selected value."
                    }
                    let desc = 'There are errors in your form, correct them before continuing.';
                    this.showMessageNotification({type: 'error', description: desc, list: val});
                }
            },
            'form.status'(val){
                this.show_secondary_status = val == 0 ? true : false;
            }
          }
      }
  
  </script>
  <style lang="scss" scoped>
  
    .strike{
      text-decoration: line-through;
      color: #a0a0a0;
    }
    .enhanced{
      font-weight: 500;
    }
    .primary-color{
      color: #00727A;
  
    }
  
    .bottom-bar-position {
      ::v-deep .hb-bab-wrapper {
        height: 63px !important;
      }
    }
  
    .hb-table {
      border-right: 0px !important;
    }
  
  </style>
  